import React from "react";

export const FulfillmentContext = React.createContext({});

export const FulfillmentProvider = FulfillmentContext.Provider;
